<template>
    <v-expand-transition>
        <v-card
            class="mx-auto"
            width="400"            
            v-show="expand"                        
        >    
            
            <v-toolbar
                color="primary"
                dark
            >
                <v-toolbar-title>Select Subject Class</v-toolbar-title>
            </v-toolbar>
            <v-list 
                light                
            >
                <v-list-item-group v-model="lessonSelected">
                    <v-list-item
                        v-for="(item, i) in lessons"
                        :key="i"
                        @click="setLesson(item)"
                    >
                        <v-list-item-avatar>
                            <v-icon class="primary white--text">
                                mdi-account-group
                            </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.lesson }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-card>
    </v-expand-transition>         
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {    
    mounted: function(){
        if(!this.admin)       
        this.getLessons();
    },

    data: () => ({
        lessons: [],
        lessonSelected: {lesson: '', className: '', subjectCode: '', subjectTitle: ''},
        open: true,
        clear: true,       
        focus: false,
        records: [],        
    }),
    
    computed: {
        ...mapGetters({            
            id: 'auth/getEmployeeId',
            lessonRecords: 'termReports/getLessons',
            expand: 'termReports/getExpandLessonOptions',
            studentsTotal: 'termReports/getSubjectStudentsTotal',
            studentsRegistered: 'termReports/getSubjectStudentsRegistered',
            studentsMarksEntered: 'termReports/getSubjectStudentsMarksEntered',                            
            admin: 'auth/getAdmin',
        }),
       
    },
    methods: {
        ...mapActions({
           getLessonRecords: 'termReports/getLessons',
           getStudents: 'termReports/getStudents',           
        }),
        ...mapMutations({
            setLessonSelected: 'termReports/setLessonSelected',
            setExpand: 'termReports/setExpandLessonOptions',
            markSheetLoading: 'termReports/setMarkSheetLoading',
            markSheetOverlay: 'termReports/setMarkSheetOverlay',
        }),

        async setLesson(lesson){
            this.setLessonSelected(lesson);
            this.setExpand(false);
            setTimeout(() => {
                this.markSheetLoading(true);
            }, 700)
            await this.getStudents(this.id);                      
        },

        async getLessons(){
            try {
                const { data } = await this.getLessonRecords();  
                
                this.markSheetLoading(false);
                this.$nextTick(() => {
                    this.setExpand(true);
                })

                if(data.length === 0){
                    this.lessons.push({
                        lesson: 'No Lessons have been assigned to you',
                        disabled: true,
                    })
                    //this.setOverlay(false);
                    return;
                }

                const lowerSchoolLessons = this.lowerSchoolLessons(data);

                let uniqueLessons = this.uniqueLessons(data);
                
                this.lessons = JSON.parse(JSON.stringify([...lowerSchoolLessons, ...uniqueLessons]));

                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            } finally {
                //this.setOverlay(false);
            }
                   
        },

        uniqueLessons (data){
            return Object.values(
                data.reduce((acc, lessonRecord) => {
                    if(lessonRecord.form_level <= 3) return acc;
                    //create a unique key based on the subject title and form level
                    const key = `${lessonRecord.subject.title}-${lessonRecord.form_level}`;

                    //if the key doesn't exist in the accumulator, add it
                    if (!acc[key]) {
                        let lesson = `Form ${lessonRecord.form_level} ${lessonRecord.subject.title}`
                        if(lessonRecord.form_level == 6) lesson = `6L ${lessonRecord.subject.title}`
                        else if(lessonRecord.form_level == 7) lesson = `6U ${lessonRecord.subject.title}`
                        acc[key] = {
                            // lesson: lessonRecord.form_class_id + ' ' + lessonRecord.subject.title,
                            lesson,
                            // classId: lessonRecord.form_class_id,                    
                            subjectCode: lessonRecord.subject.id,
                            subjectTitle: lessonRecord.subject.title,
                            formLevel: lessonRecord.form_level,
                            subject_id: lessonRecord.subject.id,
                            employee_id: lessonRecord.employee_id,
                            form_classes: [],
                        };
                    }

                    acc[key].form_classes.push(lessonRecord.form_class_id);

                    return acc;
                }, {})
            )
        },

        lowerSchoolLessons(data){
            return data.filter( record => {
                if(record.form_level >= 4) return false;
                    record.lesson = `${record.form_class_id} ${record.subject.title}`
                    record.subjectCode = record.subject.id;
                    record.form_classes = [record.form_class_id];
                    record.formLevel = record.form_level;
                    record.subjectTitle = record.subject.title;
                    return true;
                }
            )
        }

    }
}
</script>